export const TAXONOMY_BLANK = 'blank';

export const TAXONOMY_CATEGORY_PAINTING = 'painting';
export const TAXONOMY_CATEGORY_SCULPTURE = 'sculpture';
export const TAXONOMY_CATEGORY_DRAWING = 'drawing';
export const TAXONOMY_CATEGORY_SCENOGRAPHY = 'scenography';
export const TAXONOMY_CATEGORIES = [TAXONOMY_CATEGORY_PAINTING, TAXONOMY_CATEGORY_SCULPTURE, TAXONOMY_CATEGORY_DRAWING, TAXONOMY_CATEGORY_SCENOGRAPHY];
